import { createSlice } from '@reduxjs/toolkit';
import { getAboutUsInfo } from 'reduxStore/actions/AboutUs';

const initialState = {
  userLoading: false,
  aboutDetails: [],
  error: null,
};

const aboutUsSlice = createSlice({
  name: 'aboutUs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAboutUsInfo.fulfilled, (state, action) => {
        state.aboutDetails = action.payload;
        state.userLoading = false;
      })
      .addCase(getAboutUsInfo.pending, (state) => {
        state.userLoading = true;
      })
      .addCase(getAboutUsInfo.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      });
  },
});

export default aboutUsSlice.reducer;
